import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import styled from "styled-components";
import { DefaultTheme } from "styled-components";
interface IStyles {
    theme: DefaultTheme;
    selected: boolean;
}

export const ButtonContainer = styled.div<IStyles>(({ theme, selected }) => ({
    background: selected
        ? theme.colors[theme.colorMode].background_Button_Secondary
        : theme.colors[theme.colorMode].background_Primary,
    border: selected
        ? `1.5px solid ${theme.colors[theme.colorMode].primary}`
        : `1px solid ${theme.colors[theme.colorMode].border_Tertiary}`,
    boxShadow: "0px 2px 6px 0px rgba(40, 44, 63, 0.08)",
    position: "relative",
    height: `calc(${theme.spacing.xLarge} * 3)`,
    width: `calc(${theme.spacing.xLarge} * 3)`,
    borderRadius: theme.cornerRadius.medium,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
}));

export const AmountContainer = styled(Text)(({ theme }) => ({
    marginTop: theme.spacing.xxSmall,
}));

export const DiscountContainer = styled.div(({ theme }) => ({
    position: "absolute",
    top: "-6px",
    color: "white",
    backgroundColor: theme.colors[theme.colorMode].positive,
    width: `calc(${theme.spacing.xxLarge} + ${theme.spacing.small} + ${theme.spacing.xxxSmall})`,
    height: theme.spacing.small,
    borderRadius: `${theme.cornerRadius.xSmall}`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
}));

export const MostPopularAmountContainer = styled.div(({ theme }) => ({
    position: "absolute",
    top: "-6px",
    color: "white",
    backgroundColor: theme.colors[theme.colorMode].rain,
    width: `calc(${theme.spacing.xxLarge} + ${theme.spacing.small} + ${theme.spacing.xSmall})`,
    height: theme.spacing.small,
    borderRadius: `${theme.cornerRadius.xSmall}`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
}));

export const OriginalValue = styled.span`
    text-decoration: line-through;
    color: rgba(255, 255, 255, 0.6);
`;
